export default {
  shadow3: "0px 4px 5px rgba(62, 61, 63, 0.14), 0px 1px 10px rgba(62, 61, 63, 0.12), 0px 2px 4px rgba(62, 61, 63, 0.2)",
  shadow4: "0px 24px 38px rgba(131, 146, 175, 0.14), 0px 9px 46px rgba(131, 146, 175, 0.12), 0px 11px 15px rgba(131, 146, 175, 0.2)",
};
